var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "custom-input-bor",
    class: ((_vm.isEdit ? 'active' : '') + " " + (_vm.error?'error':'')),
    style: (("width: " + _vm.width + "px; height: " + _vm.height + "px; border: " + _vm.border + ";"))
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "input",
    staticClass: "custom-input",
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.onFocus,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInput],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      },
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), (_vm.unit) ? _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.unit))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._t("icon")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217cbf9f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CustomInput.vue
// module id = 8OJP
// module chunks = 138